import {
  Breakpoints,
  TextAppearance,
  TextColor,
  TextCustomProps,
  TextLineHeight,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';

export const dealerNameTextStyle: TextCustomProps = {
  appearance: TextAppearance.headline200,
  style: {
    [Breakpoints.default]: {
      fontSize: TextSize.TextSize20,
      lineHeight: TextLineHeight.TextLineHeight28,
      fontWeight: TextWeight.bold,
    },
  },
};

export const dealerDistanceTextStyle: TextCustomProps = {
  appearance: TextAppearance.copy100,
  style: {
    [Breakpoints.default]: {
      color: TextColor.primary,
      fontSize: TextSize.TextSize14,
      lineHeight: TextLineHeight.TextLineHeight24,
    },
  },
};

export const dealerDetailTextStyle: TextCustomProps = {
  appearance: TextAppearance.copy200,
  style: {
    [Breakpoints.default]: {
      fontSize: TextSize.TextSize16,
      lineHeight: TextLineHeight.TextLineHeight20,
    },
  },
};

export const dealerDetailMobileTextStyle: TextCustomProps = {
  ...dealerDetailTextStyle,
  style: {...dealerDetailTextStyle.style, color: TextColor.inherit},
};

export const dealerSiteTextStyle: TextCustomProps = {
  appearance: TextAppearance.copy200,
  style: {
    [Breakpoints.default]: {
      fontSize: TextSize.TextSize16,
      lineHeight: TextLineHeight.TextLineHeight20,
    },
  },
};
